import { memo } from "react"
import Icon from "../../../../../components/Icon"
import { ICON } from "../../../../../components/Icon/data"

import './index.scss'
import Tooltip from "../../../../../components/Tooltip"
import { useTranslation } from "react-i18next"

type AreaNameColumn = {
  visible?: boolean
  name?: string
  changeVisibility?: (visibility: boolean) => void
}

const AreaNameColumn = memo(({
  visible = true, name, changeVisibility = () => {}
}: AreaNameColumn) => {
  const { t } = useTranslation()

  return (
    <div className="AreaNameColumn">
      <div
        className="AreaNameColumn__visibility"
        role="button"
        tabIndex={0}
        onClick={(e) => {
          if (visible) e.stopPropagation()
          changeVisibility(!visible)
        }}
      >
        <Tooltip
          content={<Icon icon={visible ? ICON.VIEW_FILLED : ICON.VIEW_OFF} />}
          text={visible ? t('Hide on map') : t('Show on map')}
        />
      </div>
      {name}
    </div>
  )
})

export default AreaNameColumn
